module.exports = __webpack_public_path__ + "56bc58d4b8cc4bccc931f7667f7185e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/wrench-s.png
// module id = 2634
// module chunks = 0